import { useTranslation } from 'react-i18next'
import styles from './ContingentTables.module.scss'

const ContingentTables = ({ data }) => {
  const { t } = useTranslation('common')

  const STATUS_LABELS = {
    active: t('reports.status_active'),
    academic_leave: t('reports.status_academic_leave'),
    expelled: t('reports.status_expelled'),
    graduated: t('reports.status_graduated'),
    transferred_out: t('reports.status_transferred_out'),
    applicant: t('reports.status_applicant'),
  }

  const FORM_LABELS = {
    full_time: t('reports.form_full_time'),
    part_time: t('reports.form_part_time'),
    evening: t('reports.form_evening'),
    distance: t('reports.form_distance'),
  }

  const FUNDING_LABELS = {
    budget: t('reports.funding_budget'),
    contract: t('reports.funding_contract'),
    grant: t('reports.funding_grant'),
    targeted: t('reports.funding_targeted'),
  }

  if (!data) {
    return <div className="unv-empty">{t('reports.no_data')}</div>
  }

  const byStatus = data.by_status || {}
  const byFaculty = data.by_faculty || []
  const byCourse = data.by_course || []
  const byForm = data.by_form || []
  const byFunding = data.by_funding || []

  return (
    <div className={styles.wrap}>
      <div className={styles.kpiRow}>
        <KpiCard label={t('reports.kpi_total_active')} value={data.total} highlight />
        <KpiCard label={t('reports.status_academic_leave')} value={byStatus.academic_leave || 0} />
        <KpiCard label={t('reports.kpi_expelled_count')} value={byStatus.expelled || 0} />
        <KpiCard label={t('reports.kpi_graduates_count')} value={byStatus.graduated || 0} />
      </div>

      <div className={styles.grid}>
        <Section title={t('reports.section_by_status')}>
          <Table
            rows={Object.entries(byStatus).map(([k, v]) => ({
              key: k,
              label: STATUS_LABELS[k] || k,
              value: v,
            }))}
            t={t}
          />
        </Section>

        <Section title={t('reports.section_by_faculty')}>
          <Table rows={byFaculty.map((r, i) => ({ key: `f-${i}`, label: r.name, value: r.count }))} t={t} />
        </Section>

        <Section title={t('reports.section_by_course')}>
          <Table rows={byCourse.map((r) => ({ key: `c-${r.course}`, label: t('reports.course_n', { n: r.course }), value: r.count }))} t={t} />
        </Section>

        <Section title={t('reports.section_by_form')}>
          <Table
            rows={byForm.map((r, i) => ({
              key: `fm-${i}`,
              label: r.label || FORM_LABELS[r.form] || r.form,
              value: r.count,
            }))}
            t={t}
          />
        </Section>

        <Section title={t('reports.section_by_funding')}>
          <Table
            rows={byFunding.map((r, i) => ({
              key: `fn-${i}`,
              label: r.label || FUNDING_LABELS[r.funding] || r.funding,
              value: r.count,
            }))}
            t={t}
          />
        </Section>
      </div>
    </div>
  )
}

const KpiCard = ({ label, value, highlight }) => (
  <div className={`unv-card ${styles.kpiCard} ${highlight ? styles.kpiHighlight : ''}`}>
    <div className={styles.kpiLabel}>{label}</div>
    <div className={styles.kpiValue}>{(Number(value) || 0).toLocaleString('ru-RU')}</div>
  </div>
)

const Section = ({ title, children }) => (
  <div className={`unv-card ${styles.section}`}>
    <div className={styles.sectionTitle}>{title}</div>
    {children}
  </div>
)

const Table = ({ rows, t }) => {
  if (!rows || rows.length === 0) {
    return <div className="unv-empty">{t('reports.no_data')}</div>
  }
  return (
    <table className={`unv-table ${styles.table}`}>
      <thead>
        <tr>
          <th>{t('reports.col_category')}</th>
          <th>{t('reports.col_count')}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.key}>
            <td>{r.label}</td>
            <td><strong>{(Number(r.value) || 0).toLocaleString('ru-RU')}</strong></td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default ContingentTables
